import { render, staticRenderFns } from "./user-table.vue?vue&type=template&id=e1210cbc&scoped=true&"
import script from "./user-table.vue?vue&type=script&lang=js&"
export * from "./user-table.vue?vue&type=script&lang=js&"
import style0 from "./user-table.vue?vue&type=style&index=0&id=e1210cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1210cbc",
  null
  
)

export default component.exports